import { defineStore } from 'pinia';
import { ref } from 'vue';

// Tema fixo em light enquanto as telas são ajustadas.
// Para reativar: restaurar leitura do localStorage e toggleTheme().
export const useThemeStore = defineStore('theme', () => {
  const isDark = ref(false);

  function toggleTheme() {
    // desabilitado — sempre light por enquanto
  }

  function setDark(_value) {
    // desabilitado
  }

  return { isDark, toggleTheme, setDark };
});
